import { HelpButton } from './HelpButton';

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Application Not Found</h2>
        <p className="mt-4 text-lg text-gray-600">
          We can&apos;t find what you&apos;re looking for.
        </p>
        <div className="mt-6">
          <HelpButton variant="inline" />
        </div>
      </div>
    </div>
  );
};
